import { PermissionStatus, } from 'expo-modules-core';
export { PermissionStatus, };
//# sourceMappingURL=Camera.types.js.map